import React, { useState, useRef } from 'react'
import Slider from 'react-slick'

const TestimonialCard = ({ quote, name, title, isActive, index, onClick }) => {

    let image = ''

    if (index === 0) image = require('../../../../images/fractional/testimonial/leftTestimonial.svg')
    if (index === 1) image = require('../../../../images/fractional/testimonial/centerTestimonial.svg')
    if (index === 2) image = require('../../../../images/fractional/testimonial/rightTestimonial.svg')

    return (
        <div className={`testimonial-card ${isActive ? 'active' : ''}`} onClick={onClick}>
            <img
                className='mxa'
                width={32}
                height={32}
                src={require('../../../../images/fractional/testimonial/quote.svg')}
                alt='quote'
            />
            <div className="quote-text">{quote}</div>
            <div className="profile-section">
                <img src={image} alt={name} className="profile-image" />
                <div className="profile-info df aic fdr">
                    <div className="profile-name">{name}, </div>
                    <div className="profile-title ml0-5rem">{title}</div>
                </div>
            </div>
        </div>
    )
}

const FractionalCarouselSection = () => {
    const [currentSlide, setCurrentSlide] = useState(2) // center by default
    const sliderRef = useRef(null)

    const testimonials = [
        {
            quote: "You're solving a problem every CFO and founder recognises but dreads tackling.",
            name: "MC",
            title: "Fractional CFO",
        },
        {

            quote: "It gives me a way to upsell into clients.",
            name: "AW",
            title: "Fractional CFO"
        },
        {
            quote: "I think it's equally useful whether someone's scaling up or cleaning up.",
            name: "RC",
            title: "Fractional CFO"
        }
    ]

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        initialSlide: 1,
        afterChange: (index) => {
            const visibleSlides = 3 // desktop default
            const centerOffset = Math.floor(visibleSlides / 2) // center = 1 when 3 slides shown
            const centerIndex = (index + centerOffset) % testimonials.length
            setCurrentSlide(centerIndex)
        },
        appendDots: (dots) => (
            <ul style={{ margin: '0px', padding: '0px' }}> {dots} </ul>
        ),
        customPaging: (i) => (
            <div
                style={{
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    transition: 'all 0.3s',
                }}
            />
        ),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    initialSlide: 0,
                    afterChange: (index) => setCurrentSlide(index)
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    initialSlide: 0,
                    afterChange: (index) => setCurrentSlide(index)
                }
            }
        ]
    }

    const handleCardClick = (index) => {
        if (sliderRef.current && index !== currentSlide) {
            sliderRef.current.slickGoTo(index)
        }
    }

    return (
        <div className="testimonial-carousel-section">
            <div className="testimonial-carousel-container">
                <Slider ref={sliderRef} {...settings}>
                    {testimonials.map((testimonial, index) => (
                        <TestimonialCard
                            key={index}
                            index={index}
                            {...testimonial}
                            isActive={index === currentSlide}
                            onClick={() => handleCardClick(index)}
                        />
                    ))}
                </Slider>
            </div>
        </div>
    )
}

export default FractionalCarouselSection
